import React, {Component} from 'react'
import {_getTotalRemainJobs} from "../../../../../../services/apis/SearchHistoryServices"
import formatThousandNumber from "../../../../../../helpers/common/formatThousandNumber"

class SKRemainJobs extends Component {
    state = {
        total: 0
    }

    _refresh = null
    _refreshTime = 10000

    componentDidMount() {
        this._fetchTotal()
        this._refresh = setInterval(this._fetchTotal, this._refreshTime)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchTotal = async () => {
        const {success, data} = await _getTotalRemainJobs()

        success && this.setState({
            total: parseInt(data, 10)
        })
    }

    render() {
        const {total} = this.state

        return (
            <div className="SKRemainJobs">
                <strong>Remain jobs:</strong>
                <span className="Number"> {formatThousandNumber(total)} jobs</span>
            </div>
        )
    }
}

export default SKRemainJobs



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/sps/SKRemainJobs.js